import types from '../actions/types';
import { getAge } from '../helpers';

const initialState = {
  personName: '',
  personEmail: '',

  personGender: '',
  personBirthdate: '',
  personAge: 0,

  disease: null,
  capital: 0,

  annualCost: 0,
  monthlyCost: 0,

  quoteAccepted: null,

  sendMailStatus: null
};

const cleanableState = {};

const health = (state = { ...initialState, ...cleanableState }, action) => {
  switch (action.type) {
    case types.CLEAN: {
      return { ...initialState };
    }

    case types.SET_HEALTH_VALUE: {
      const { type, value } = action.payload;
      return {
        ...state,
        [type]: value
      };
    }

    case types.SET_PERSON_BIRTHDATE:
      return {
        ...state,
        personBirthdate: action.payload,
        personAge: getAge(action.payload)
      };

    case types.SET_QUOTATION_SALUD:
      return {
        ...state,
        annualCost: Math.round(action.payload),
        monthlyCost: Math.round((Math.round(action.payload) / 12) * 100) / 100
      };

    default:
      return state;
  }
};

export default health;
